import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Card, CardImg, CardBody, CardText } from "reactstrap";
import compoundImg from "assets/images/bg.png";
import compoundLogo from "assets/images/compound.png";
import AuthCard from "components/Website/Cards/AuthCard";
import { useSelector, useDispatch } from "react-redux";
import { authenticate, addInterest } from "store/Auth/actions";
import developerdImg from "assets/images/developer_logo.png";
import { useTranslation } from "react-i18next";

function CompoundCard({ compound, deleteCompound, history, location }) {
	// const [modal, setModal] = useState(false)
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const checkAuth = () => {
		if (AuthData.token && AuthData.userType === "user") {
			history.push(`/compound-details/${compound.id}`);
		} else {
			dispatch(
				authenticate({ navigateTo: `/compound-details/${compound.id}` })
			);
			history.push(`/login`, {
				navigateTo: `/compound-details/${compound.id}`,
			});
		}
	};
	return (
		<div className="position-relative">
			<div className="comCard mx-2">
				{compound?.images?.length > 0 ? (
					compound?.images?.map((img, index) => {
						if (index === 0) {
							return (
								<CardImg
									key={index}
									src={img.path}
									style={{
										padding: "10px",
										borderRadius: "45px",
									}}></CardImg>
							);
						}
					})
				) : (
					<CardImg
						src={compoundImg}
						style={{
							padding: "10px",
							borderRadius: "45px",
						}}></CardImg>
				)}

				<CardBody style={{ padding: "18px" }}>
					<Row>
						<Col md={12}>
							<CardText tag="h4" className="text-primary font-size-20 fw-bold">
								{compound?.name[`${AuthData.lang}`]
									? compound?.name[`${AuthData.lang}`]
									: compound?.name?.en}
							</CardText>
						</Col>
					</Row>
					<CardText tag="h4" className="text-primary font-size-14">
						{compound.address[`${AuthData.lang}`]
							? compound.address[`${AuthData.lang}`]
							: compound.address?.en}
						,{" "}
						{compound.city?.name[`${AuthData.lang}`]
							? compound.city?.name[`${AuthData.lang}`]
							: compound.city?.name?.en}
					</CardText>

					<hr className="text-primary mb-0" />

					<Row className="pt-2">
						<Col md={12} className="mb-3">
							<CardText tag="p" className="font-size-10 text-color mb-1">
								{t("starting from")}
							</CardText>
							<CardText tag="h4" className="text-primary font-size-16">
								{toCurrency(compound?.starting_from)} {currency?.currency_code}
							</CardText>
						</Col>
						<Col md={12} className="mb-0">
							<CardText tag="p" className="font-size-10 text-color mb-1">
								{t("to")}
							</CardText>
							<CardText tag="h4" className="text-primary font-size-16 mb-0">
								{toCurrency(compound?.end_to)} {currency?.currency_code}
							</CardText>
						</Col>
					</Row>

					<hr className="text-primary mb-2 mt-1" />

					<Row>
						<Col md={12}>
							<CardText tag="h4" className="text-color font-size-10">
								{t("installment with Seller")}
							</CardText>
							<CardText tag="h4" className="text-primary font-size-14">
								{compound?.installment
									? t("up to installment", { num: compound?.installment })
									: t("only cash")}
							</CardText>
						</Col>
					</Row>

					<hr className="text-primary mb-2 mt-1" />

					<Row>
						<Col md={12}>
							<CardText tag="h4" className="text-color font-size-10 mb-2">
								{t("facilities")}
							</CardText>
							{compound?.facilities?.map((res) => (
								<CardText tag="h4" className="text-primary font-size-14 mb-1">
									{res?.name[`${AuthData.lang}`]
										? res?.name[`${AuthData.lang}`]
										: res?.name?.en}
								</CardText>
							))}
						</Col>
					</Row>

					<hr className="text-primary mb-2 mt-1" />

					<Row>
						<Col md={12}>
							<CardText tag="h4" className="text-color font-size-10 mb-2">
								{t("Units Types")}
							</CardText>
							{compound?.unit_types?.map((res) => (
								<CardText tag="h4" className="text-primary font-size-14 mb-1">
									{res?.name[`${AuthData.lang}`]
										? res?.name[`${AuthData.lang}`]
										: res?.name?.en}
								</CardText>
							))}
						</Col>
					</Row>

					<hr className="text-primary mb-2 mt-1" />

					<CardText
						tag="h4"
						onClick={() => checkAuth()}
						style={{ textDecoration: "underline" }}
						className="text-primary font-size-12 text-center my-3">
						{t("View Compound")}
					</CardText>

					<hr className="text-primary mb-2 mt-1" />

					<CardText
						tag="h4"
						onClick={() => {
							deleteCompound(compound.id);
						}}
						className="text-primary font-size-12 text-center">
						{t("remove")}
					</CardText>
				</CardBody>
			</div>
		</div>
	);
}
const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default CompoundCard;
